const APP_CONFIG = {
  version: "7.84.0",
  title: "Claire V7.84.0",
  version_client: "7.84.0",
};

export default APP_CONFIG;
